import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

import { AiSnippetEnum } from "@/enum/ai-enrichment.enum";

const { REQUIRED, INVALID_VALUE } = ERROR_TYPE;

export const SNIPPET_NAME_PATTERN = /^[^{}|]+$/;

export const MAX_FEW_SHOT_EXAMPLES = 5;

export const FewShotExampleSchema = z.object({
	leadContext: z.string().min(1, { message: REQUIRED }).trim(),
	idealOutput: z.string().min(1, { message: REQUIRED }).trim(),
});

export const AiSnippetSchema = z.object({
	name: z
		.string()
		.min(2, { message: REQUIRED })
		.trim()
		.regex(SNIPPET_NAME_PATTERN, { message: INVALID_VALUE }),
	prompt: z.string().min(4, { message: REQUIRED }).trim(),
	systemPrompt: z.string().optional(),
	promptType: z.nativeEnum(AiSnippetEnum),
	allowedValues: z.array(z.string()).optional(),
	fewShotExamples: z.array(FewShotExampleSchema).max(MAX_FEW_SHOT_EXAMPLES).optional(),
});

export type FewShotExample = z.infer<typeof FewShotExampleSchema>;

export type AiSnippetType = z.infer<typeof AiSnippetSchema>;
